import { createClient } from '@supabase/supabase-js';
const supabaseUrl = `https://${process.env.REACT_APP_SUPABASE_PROJECT_ID}.supabase.co`;
export const supabase = createClient(
  supabaseUrl,
  `${process.env.REACT_APP_SUPABASE_SECRET_KEY}`,
);
